import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const photos = [
    {
        src: "/images/boutique-vue-ensemble.jpg",
        caption: "L'espace conseil",
        n: "01",
        size: "lg:col-span-7 lg:row-span-2 aspect-[4/3] lg:aspect-auto lg:h-[640px]",
    },
    {
        src: "/images/espace-examen.jpg",
        caption: "L'espace examen de vue",
        n: "02",
        size: "lg:col-span-5 aspect-[4/3] lg:aspect-auto lg:h-[310px]",
    },
    {
        src: "/images/coin-cosy.jpg",
        caption: "L'atelier",
        n: "03",
        size: "lg:col-span-5 aspect-[4/3] lg:aspect-auto lg:h-[310px]",
    },
];

export default function Apercu() {
    return (
        <section
            id="apercu"
            className="relative py-24 md:py-32 bg-lpl-bg-alt"
            data-testid="apercu-section"
        >
            <div className="max-w-7xl mx-auto px-5 md:px-10">
                <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-10 mb-14">
                    <div>
                        <h2
                            className="font-display font-semibold text-5xl md:text-7xl text-lpl-text leading-[0.95] tracking-tight"
                            data-testid="apercu-title"
                        >
                            Un coup d'œil dans{" "}
                            <span className="font-serif italic font-normal text-lpl-primary-deep">
                                la boutique
                            </span>
                            <span className="font-serif italic font-normal text-lpl-lavender">
                                .
                            </span>
                        </h2>
                    </div>
                    <p className="lg:max-w-sm text-lpl-text-muted text-base md:text-lg leading-relaxed">
                        Du bois clair, un mur vert qu'on aime un peu trop, des
                        chaises qui invitent à s'installer. Et vous au milieu.
                    </p>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 md:gap-5 auto-rows-min">
                    {photos.map((p, i) => (
                        <motion.figure
                            key={p.src}
                            initial={{ opacity: 0, y: 40 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-80px" }}
                            transition={{ duration: 0.7, delay: i * 0.1 }}
                            className={`relative group overflow-hidden ${p.size}`}
                            data-testid={`apercu-photo-${i}`}
                        >
                            <img
                                src={p.src}
                                alt={p.caption}
                                className="w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-700 ease-out"
                                loading="lazy"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-lpl-text/60 via-transparent to-transparent" />
                            <figcaption className="absolute inset-x-0 bottom-0 p-5 md:p-7 flex items-end justify-between text-lpl-bg">
                                <span className="font-display font-semibold text-xl md:text-2xl">
                                    {p.caption}
                                </span>
                                <span className="font-serif italic text-2xl md:text-3xl opacity-80">
                                    {p.n}
                                </span>
                            </figcaption>
                        </motion.figure>
                    ))}
                </div>

                <div className="mt-16 md:mt-20 flex flex-col md:flex-row items-start md:items-center justify-between gap-6 border-t border-lpl-border pt-10">
                    <p className="font-serif italic text-2xl md:text-3xl text-lpl-text max-w-xl leading-tight">
                        On vous garde le meilleur café, et notre meilleure
                        humeur.
                    </p>
                    <Link
                        to="/contact"
                        data-testid="apercu-cta-visit"
                        className="group inline-flex items-center gap-3 bg-lpl-primary text-lpl-text px-7 py-4 rounded-full text-sm uppercase tracking-[0.16em] font-semibold hover:bg-lpl-text hover:text-lpl-bg transition-colors duration-300"
                    >
                        Venir nous voir
                        <ArrowUpRight
                            size={18}
                            className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform"
                        />
                    </Link>
                </div>
            </div>
        </section>
    );
}
